import React, { useState } from 'react';
import { CopyOutlined } from '@ant-design/icons';
import RibbonButton from 'common/components/button/RibbonButton';
import ModalCopyQasRequireFields from './ModalCopyQasRequireFields';
// redux
import { useSelector } from 'react-redux';
import gridSelector from 'common/components/grid-view/controllers/selectors';

const CopyQasRequireFields = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const selectedDetail = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const id = selectedDetail?.length === 1 ? selectedDetail[0].id : undefined;

  const handleClick = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <>
      <RibbonButton
        icon={<CopyOutlined />}
        label={'Copy'}
        disabled={id === undefined || selectedDetail.length !== 1}
        onClick={handleClick}
      />
      {isModalOpen && (
        <ModalCopyQasRequireFields
          id={id}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
};

export default CopyQasRequireFields;
